export class PulseChain {
    private static _symbols: Map<string, string> = new Map<string, string>();

    private static _AddSymbol(address:string, symbol:string)
    {
        PulseChain._symbols.set(this._NormalizeTokenKey(address), symbol);
    }
    private static _NormalizeTokenKey(token: string): string { return (token ?? '').toLowerCase(); }

    private static _inited = false;
    public static Initialize()
    {
        if (PulseChain._inited) return;
        PulseChain._inited=true;
        PulseChain._AddSymbol('0xefd766ccb38eaf1dfd701853bfce31359239f305', 'DAI(ETH)')
        PulseChain._AddSymbol('0x57fde0a71132198BBeC939B98976993d8D89D225', 'eHEX(ETH)')
        PulseChain._AddSymbol('0xb17D901469B9208B17d916112988A3FeD19b5cA1', 'WBTC(ETH)')
        PulseChain._AddSymbol('0x02DcdD04e3F455D838cd1249292C58f3B79e3C3C', 'WETH(ETH)')
        PulseChain._AddSymbol('0x15d38573d2feeb82e7ad5187ab8c1d52810b1f07', 'USDC(ETH)')
        PulseChain._AddSymbol('0x0cb6f5a34ad42ec934882a05265a7d5f59b51a2f', 'USDT(ETH)')
        PulseChain._AddSymbol('0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', 'WBTC(pWBTC Airdrop)')
        PulseChain._AddSymbol('0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', 'USDC(pUSDC Airdrop)')
        PulseChain._AddSymbol('0xdAC17F958D2ee523a2206206994597C13D831ec7', 'USDT(pUSDT Airdrop)')
        PulseChain._AddSymbol('0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', 'WETH(pWETH Airdrop)')

    }

    public static GetSymbolOrDef(address:string, def:string):string
    {
        PulseChain.Initialize();
        const result = PulseChain.GetSymbol(address);
        if (!result) return def;
        return result;
    }

    public static GetSymbol(address:string):string|undefined
    {
        PulseChain.Initialize();
        const key = PulseChain._NormalizeTokenKey(address);
        if (!PulseChain._symbols.has(key)) return;
        return PulseChain._symbols.get(key);
    }
    public static SetSymbol(address:string, symbol:string)
    {
        PulseChain.Initialize();
        const key = PulseChain._NormalizeTokenKey(address);
        if (!PulseChain._symbols.has(key)) return;
        PulseChain._symbols.set(key, symbol);
    }
}
